export const components = {
  emptyState: {
    primaryTitle: 'Oeps!',
    primaryText: 'Er is hier nog niets…',
    secondaryTitle: 'Niets om weer te geven',
    secondaryText: 'Helaas zijn er geen items om weer te geven op basis van toegepaste filters…'
  },
  filters: {
    all: 'Allemaal',
    search: 'Zoeken',
    priceRange: 'Prijsbereik {currency}',
    minValue: 'De minimale waarde is {val}!',
    maxValue: 'De maximale waarde is {val}!',
    reset: 'Resetten',
    apply: 'Toepassen'
  },
  comments: {
    reply: 'Beantwoorden',
    loadMore: 'Meer laden',
    edited: 'Bewerkt',
    noComments: 'Er zijn nog geen opmerkingen',
    leaveFirstComment: 'Je kunt de eerste achterlaten'
  },
  curtain: {
    close: 'Sluiten'
  },
  photoPreview: {
    close: 'Sluiten'
  },
  photoCropper: {
    back: 'Terug',
    save: 'Opslaan'
  },
  rightSidebar: {
    in: 'in'
  },
  pushPrompt: {
    title: '“{appName}” zou je meldingen willen sturen',
    description:
      'Meldingen kunnen meldingen, geluiden en pictogrambadges bevatten. Deze kunnen worden geconfigureerd in Instellingen.',
    later: 'Vraag me later',
    neverLater: 'Nooit meer vragen',
    allow: 'Toestaan'
  },
  inAppPush: {
    attachment: 'Bijlage'
  },
  installPrompt: {
    android: {
      install: 'Installeren',
      description: 'Voor een naadloze ervaring hoef je geen browser te gebruiken. Installeer het gewoon als een app.',
      press: 'Druk op',
      andSelect: 'en selecteer',
      orSimply: 'of gewoon',
      description2: 'klik op de knop Installeren hieronder',
      notNow: 'Niet nu'
    },
    ios: {
      justTap: 'Tik op de',
      buttonInBrowser: '"Meer" knop in je browser en selecteer "Deel"',
      addToHomeScreen: 'Scroll naar beneden en tik op "Zet op beginscherm", klik dan op "Voeg toe"',
      appWillBeInstalled: 'De app wordt toegevoegd aan je beginscherm'
    },
    installApp: 'App installeren',
    useWeb: 'Gebruik webversie'
  },
  footer: {
    more: 'Menu'
  },
  menu: {
    installApp: 'App installeren',
    menu: 'Menu',
    close: 'Sluiten'
  },
  404: {
    whoops: 'Oeps!',
    description:
      'Het lijkt erop dat de pagina niet bestaat of misschien heb je er geen toegang toe. Neem contact op met de eigenaar van de app voor meer informatie.',
    ok: 'OK'
  },
  relatedUsers: {
    seeall: 'Alles bekijken'
  },
  networkingCurtain: {
    'newOneOnOne': 'Nieuwe 1:1',
    'details': 'Details',
    'coverMessage': 'Omslagbericht',
    'location': 'Locatie',
    'duration': 'Duur',
    '15min': '15 min',
    '30min': '30 min',
    '45min': '45 min',
    '60min': '60 min',
    'timeSlot': 'Tijdslot',
    'sendInvitation': 'Uitnodiging verzenden',
    'success': 'Succes',
    'invitationSent':
      "Je hebt de uitnodiging voor een 1:1-ontmoeting succesvol verzonden. Wil je op deze pagina blijven of wil je naar al je geplande 1:1's navigeren?",
    'seeAll': 'Bekijk alle 1:1 ontmoetingen',
    'stayHere': 'Blijf hier'
  },
  networking: {
    level: {
      1: 'Nog niet klaar om te netwerken. Geen significante activiteit of betrokkenheid.',
      2: 'Zelden actief of mist belangrijke profielinformatie, waardoor het moeilijk is voor anderen om verbinding te maken.',
      3: 'Profiel is compleet met foto en online, volledig voorbereid om te beginnen met netwerken.',
      4: 'Bouwt momentum op - heeft in de afgelopen 6 uur ten minste één verbinding geïnitieerd.',
      5: 'Een netwerkmaster - reageert actief op verzoeken en is betrokken bij anderen in de afgelopen 6 uur.'
    }
  },
  time: {
    days: 'd',
    hours: 'h',
    minutes: 'm',
    seconds: 's',
    startsIn: 'over',
    Today: 'Vandaag',
    today: 'vandaag',
    Tomorrow: 'Morgen',
    tomorrow: 'morgen',
    Yesterday: 'Gisteren',
    yesterday: 'gisteren',
    startingNow: 'begint nu'
  },
  daysMonths: {
    months: "['Januari','Februari','Maart','April','Mei','Juni','Juli','Augustus','September','Oktober','November','December']",
    monthsShort: "['Jan', 'Feb', 'Mrt', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec']",
    weekdays: "['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag']",
    weekdaysShort: "['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za']",
    weekdaysMin: "['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za']"
  },
  badges: {
    legend: 'Legendary Networker',
    push: 'Online and Trusted',
    leader: 'Leaderboard Champ',
    meetmaster: '1:1 Meeting Master',
    connector: '3-Time Connector',
    legend_description: 'Bereik het Legend-niveau ten minste één keer door actief te netwerken en zinvolle verbindingen te maken.',
    push_description: 'Sta pushmeldingen toe om altijd bereikbaar te blijven en geen kans te missen.',
    leader_description: 'Kom minstens één keer in de top 10% van het leaderboard.',
    meetmaster_description: 'Start of reageer op ten minste één 1:1 vergaderverzoek binnen de app.',
    connector_description: 'Maak ten minste drie verbindingen via de app tijdens componenten.'
  }
}
